<template>
  <Card tag="form" class="project-flatfinder-mutate-builder" @submit.prevent="$emit('submit')">
    <template #default>
      <Flatfinder
        v-if="value.image && $parent.active.id === 'builder'"
        v-model="value.items"
        :id="value.id"
        :image="value.image.url"
      />
    </template>
  </Card>
</template>

<script>
import { i18n } from '@/i18n'

import Card from '@/components/Card'
import { InputComponent } from 'vue-elder-input'
import Flatfinder from '@/components/Flatfinder'

const meta = {
  order: 1,
  id: 'builder',
  label: i18n.t('flatfinderBuilder'),
  icon: ['fal', 'file-alt'],
}

export { meta }
export default {
  props: {
    value: Object,
    labels: Object,
    validator: Object,
  },
  components: {
    Card,
    InputComponent,
    Flatfinder,
  },
}
</script>

<style lang="scss">
.project-flatfinder-mutate-builder {
  &__input {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: $form-gap;
  }

  & > .card__content {
    padding: 0.2rem;

    .leaflet__map {
      background-color: transparent;
      border-radius: var(--border-radius-md);
    }
  }
}
</style>
